/**
 * LP ATTRIBUTION GUARD — last-click PURO pra TODAS as origens de venda (LPs + PDPs)
 *
 * Modelo: a venda conta pra uma ORIGEM (LP ou PDP) se a ÚLTIMA página de venda tocada
 * antes da compra foi essa origem. Sair pra QUALQUER página comum do tema (home, coleção,
 * blog, etc.) ZERA o `_lp_source`. Ir DIRETO de uma origem pra outra transfere o crédito
 * pra última (o lp-source-tracker.js regrava). Origens:
 *  - LPs de venda → `_lp_source = <slug>` (ex: 'lp-5-razoes-bundles'). Lista em __lpTrackedSlugs.
 *  - PDPs (/products/*) → `_lp_source = 'pdp:<handle>'` (prefixo 'pdp:'). Ver main-product.liquid.
 *
 * DOIS EIXOS (sinais globais do Liquid):
 *  - `window.__lpGuardExempt = true`  → página do FLUXO DE COMPRA (LP rastreada / /cart /
 *    checkout). Guard ABORTA cedo, não roda. Ver o carrinho antes de pagar NÃO desqualifica;
 *    checkout nem renderiza o tema (isento por natureza).
 *  - `window.__lpIsSourcePage = true` → esta página É ORIGEM (LP OU PDP). Guard RODA, mas NÃO
 *    apaga `_lp_source` (o tracker desta página vai regravá-lo — evita race). É o que permite
 *    a PDP (não-isenta) gravar sua origem sem o guard apagar na mesma página.
 *
 * Como funciona em conjunto:
 *  - `lp-source-tracker.js` (nas sections de LP E em main-product.liquid) GRAVA a origem.
 *  - ESTE guard, GLOBAL via theme.liquid, APAGA o `_lp_source` só em página NÃO-isenta E
 *    NÃO-origem, SE o valor atual for NOSSO: LP rastreada (lista) OU PDP (regex /^pdp:/).
 *    Qualquer outro valor (UTM/campanha externa futura) fica intocado.
 *  - MESMO MODELO pros atributos do A/B (`_ab*_variant`/`_ab*_test`): expiram ao sair do
 *    funil → o A/B também é last-click puro. ATENÇÃO: o guard limpa `_ab_*` MESMO em PDP
 *    (a PDP é origem de _lp_source, mas sair da LP p/ PDP DEVE expirar o A/B — correto).
 *
 * NÃO inclui `lp-sejaumlojista` (LP B2B de lead, sem checkout — nada a atribuir de receita).
 *
 * Guard rails: try/catch em tudo (jamais quebra a página), skip se nada a limpar (evita
 * request inútil em ~todo pageview), header X-LP-Tracker.
 */
(function () {
  'use strict';

  // Idempotência: não rodar 2x na mesma página
  if (window.__lpGuardActive) return;
  window.__lpGuardActive = true;

  var ATTR_KEY = '_lp_source';
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var TRACKED = Array.isArray(window.__lpTrackedSlugs) ? window.__lpTrackedSlugs : [];
  var PDP_RE = /^pdp:/;                               // origens de PDP: _lp_source = 'pdp:<handle>'
  var IS_SOURCE = window.__lpIsSourcePage === true;   // esta página é ORIGEM (LP ou PDP) → não apaga _lp_source

  // Páginas isentas (LP rastreada, /cart, checkout) não apagam: fazem parte do fluxo
  // de compra. Na LP o lp-source-tracker.js grava o attribute; aqui é no-op. Só agimos
  // nas DEMAIS páginas (apagar o crédito quando o cliente navega pra longe da LP).
  if (window.__lpGuardExempt === true) return;
  if (!TRACKED.length) return;

  function safe(fn) {
    return function () {
      try { return fn.apply(null, arguments); }
      catch (e) { /* silencioso por design */ }
    };
  }

  function getCart() {
    return fetch(ROOT + 'cart.js', {
      headers: { 'Accept': 'application/json', 'X-LP-Tracker': '1' }
    }).then(function (r) { return r.json(); });
  }

  // Atributos do A/B (motores ab-test.js / ab-test-2.js). São carimbados no EXPOSURE
  // (1º clique num bundle da LP) e, como o _lp_source, devem seguir LAST-CLICK: se o
  // cliente sai do funil pra uma página comum (aqui = não-isenta), o crédito do A/B
  // também expira. Sem isso, quem foi exposto e comprou FORA do funil ainda contava
  // pro variante (não era last-click). Limpamos os 3 slots + seus _test.
  var AB_KEYS = ['_ab_test', '_ab_variant', '_ab1_test', '_ab1_variant', '_ab2_test', '_ab2_variant'];

  // Monta 1 POST /cart/update.js só com as chaves que precisam virar '' (remoção).
  function clearAttributes(keys) {
    var attrs = {};
    keys.forEach(function (k) { attrs[k] = ''; });
    return fetch(ROOT + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-LP-Tracker': '1'
      },
      body: JSON.stringify({ attributes: attrs })
    });
  }

  var run = safe(function () {
    getCart().then(function (cart) {
      try {
        var a = (cart && cart.attributes) || {};
        var toClear = [];
        // _lp_source: só expira se ESTA página NÃO for origem (last-click puro). Numa PDP/LP
        // (origem) o tracker regrava; apagar aqui criaria race. Fora do funil (home/coleção),
        // apaga qualquer valor NOSSO: LP rastreada (lista __lpTrackedSlugs) OU origem de PDP
        // (prefixo 'pdp:'). Valores de terceiros (UTM/campanha externa futura) não batem em
        // nenhum dos dois → intocados.
        var cur = a[ATTR_KEY];
        if (!IS_SOURCE && cur && (TRACKED.indexOf(cur) !== -1 || PDP_RE.test(cur))) toClear.push(ATTR_KEY);
        // _ab_*: apaga qualquer slot que esteja setado (fora do funil = perde o A/B).
        // Roda MESMO em PDP (origem de _lp_source): sair da LP p/ PDP expira o A/B (correto).
        AB_KEYS.forEach(function (k) { if (a[k]) toClear.push(k); });
        if (!toClear.length) return;   // nada a limpar → sem request
        return clearAttributes(toClear);
      } catch (e) {}
    }).catch(function () { /* silencioso */ });
  });

  // Folga de 500ms pra deixar outros scripts (ecobag-gift) instalarem o fetch
  // interceptor primeiro — espelha o init do lp-source-tracker.js.
  setTimeout(run, 500);
})();
